import { Grid2, Skeleton } from '@mui/material';
import { describeTrigger } from '../../../helpers/marketing/automations';
import {
  AutomationListItem,
  AutomationRecipe,
} from '../../../types/marketing/automations';
import { AutomationRecipeCard, BuildYourOwnCard } from './AutomationRecipeCard';

const SKELETON_COUNT = 5;

interface Props {
  recipes: AutomationRecipe[];
  isPending: boolean;
  automationsByRecipeId: Map<string, AutomationListItem>;
  isStatusUnavailable: boolean;
  onSetUpRecipe: (recipe: AutomationRecipe) => void;
  onBuildYourOwn: () => void;
  onViewAutomation: (automationId: string) => void;
}

function AutomationRecipeGallery({
  recipes,
  isPending,
  automationsByRecipeId,
  isStatusUnavailable,
  onSetUpRecipe,
  onBuildYourOwn,
  onViewAutomation,
}: Props) {
  if (isPending) {
    return (
      <Grid2 container columns={{ xs: 1, sm: 2, md: 3, lg: 4 }} spacing={2.5}>
        {Array.from({ length: SKELETON_COUNT }, (_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Grid2 key={index} size={1}>
            <Skeleton variant="rectangular" height={200} />
          </Grid2>
        ))}
      </Grid2>
    );
  }

  return (
    <Grid2 container columns={{ xs: 1, sm: 2, md: 3, lg: 4 }} spacing={2.5}>
      {recipes.map(recipe => {
        const existingAutomation = automationsByRecipeId.get(recipe.id) ?? null;
        return (
          <AutomationRecipeCard
            key={recipe.id}
            recipe={recipe}
            summary={describeTrigger({
              triggerEvent: recipe.triggerEvent,
              delaySeconds: recipe.delaySeconds,
              serviceCategories: recipe.serviceCategories,
            })}
            existingAutomation={existingAutomation}
            isSetUpDisabled={isStatusUnavailable}
            onSetUp={() => onSetUpRecipe(recipe)}
            onViewExisting={() => {
              if (existingAutomation) onViewAutomation(existingAutomation.id);
            }}
          />
        );
      })}
      <BuildYourOwnCard onClick={onBuildYourOwn} />
    </Grid2>
  );
}

export default AutomationRecipeGallery;
